const SearchUserStatus = {
  Resignation: "RESIGNATION"};

export { SearchUserStatus };
//# sourceMappingURL=search-user-status.mjs.map
